<template>
  <v-text-field
    v-model="selected"
    :label="label"
    outlined
    light
    dense
    input-class="dense"
    :rules="rule"
    :hint="displayAccHint ? hint : ''"
    :persistent-hint="false"
    @keyup="validadeMaxLength()"
  />
</template>

<script>
import formModal from '@/mixins/form-modal';
import { mapState } from 'vuex';

export default {
  name: 'UniversesFilter',
  mixins: [
    formModal,
  ],
  props: {
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    characters: {
      type: Number,
      default: null,
    },
    hint: {
      type: String,
      default: '',
    },
    isNumberRule: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      maxCharacters: this.characters,
    };
  },
  computed: {
    ...mapState('misc', [
      'formModal',
    ]),
    rule() {
      return this.isNumberRule ? this.isNumber : this.existsDashboard;
    },
    selected: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      }
    }
  },
  methods: {
    validadeMaxLength() {
      if (this.selected.length > this.maxCharacters) {
        this.selected = this.selected.slice(0, this.maxCharacters);
      }
    },
  },
};
</script>

<style scoped lang="scss">
  .v-input {
    width: 287px !important;
  }
</style>

